app.controller("RestoreController", ["$scope", "AuthService", "$state", "$stateParams",
    function ($scope, AuthService, $state, $stateParams) {


        $scope.passwordPattern = '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\\*\\!\\@\\$\\%\\^\\&\\(\\)\\{\\}\\[\\]\\:\\;\\<\\>\\,\\.\\?\\/\\~\\_\\+\\-\\=\\|]).{8,50}$'


        $scope.submit = function () {
            if(!$scope.resetForm.$valid) {
                $scope.state = '';
                return;
            }
            if ($scope.password !== $scope.password2) {
                $scope.state = 'password_not_match';
                return;
            }
            AuthService.resetPassword({
                restore: $stateParams.token,
                password: $scope.password
            }).then(function () {
                $scope.state = 'success';
            }).catch(function (err) {
                console.error(err);
                $scope.state = 'error';
            })
        }
    }
]);
